import React from "react";
import GIEFooterTop from './GIEFooterTop'
import GIEFooterDown from './GIEFooterDown';
import './Footer.css'

class GIEFooter extends React.Component<any, any> {
  render() {
    return (
      <footer className="footer-wrap">
        <div className="container px-0">
          <GIEFooterTop/>
          <GIEFooterDown/>
        </div>
      </footer>
    );
  }
}

export default GIEFooter;
